import { AutocompleteArrayInput, AutocompleteArrayInputProps, useTranslate } from 'react-admin';
import { InputLabel, OutlinedInputProps } from '@mui/material';
import { InputHelperUnderLabel } from './InputHelperUnderLabel';

export const GrayAutocompleteArrayInputWithUpperLabel = (props: AutocompleteArrayInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();
  const {
    helperText, isRequired, label, className, ...rest
  } = props;

  return (
    <>
      {label !== false && (
        <InputLabel className="input-label" required={isRequired}>
          {translate(typeof label === 'string' ? label : '', { _: label })}
        </InputLabel>
      )}
      <InputHelperUnderLabel helperText={helperText} />
      <AutocompleteArrayInput
        {...rest}
        className={className ? `${className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        TextFieldProps={{
          ...props.TextFieldProps,
          InputProps: {
            ...props.TextFieldProps?.InputProps,
            notched: false,
          } as OutlinedInputProps,
        }} componentsProps={{
          ...props.componentsProps,
          paper: {
            ...props.componentsProps?.paper,
            sx: {
              boxShadow: '0 2px 8px 4px lightgray',
              ...props.componentsProps?.paper?.sx,
            },
          },
        }} sx={props.sx}/>
    </>
  );

};
